import type { SVGProps } from 'react';

const MinusCircle = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.50009 12C4.50009 7.8579 7.85793 4.50006 12 4.50006C16.1422 4.50006 19.5 7.8579 19.5 12C19.5 16.1421 16.1422 19.4999 12 19.4999C7.85793 19.4999 4.50009 16.1421 4.50009 12Z"
      stroke="currentColor"
      strokeWidth="1.55171"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.362 12H8.63791"
      stroke="currentColor"
      strokeWidth="1.55171"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MinusCircle;
